<template>
  <div id="conteudo-acao" v-if="!loading && dadosAcaoResponse" v-show="!telaAberta">
    <Breadcrumb :items="breadcrumbItems" />

    <!-- MENU SUPERIOR -->
    <section id="menu-container">
      <div id="menus">
        <div class="item">
          <a>Central PREX</a>
        </div>
      </div>
    </section>

    <!-- CONTEÚDO DINÂMICO COM LAYOUT CENTRAL PREX -->
    <div id="conteudo-dinamico">
      <div class="central-layout">
        <!-- MENU LATERAL -->
        <div class="menu-lateral">
          <div class="item-lateral" :class="{ ativo: secaoAtiva === 'sem-nome-1' }" @click="secaoAtiva = 'sem-nome-1'">
            Credenciais
          </div>
          <div class="item-lateral" :class="{ ativo: secaoAtiva === 'noticias' }" @click="secaoAtiva = 'noticias'">
            Noticias
          </div>
          <div class="item-lateral" :class="{ ativo: secaoAtiva === 'parcerias' }" @click="secaoAtiva = 'parcerias'">
            Parcerias
          </div>
          <div class="item-lateral" :class="{ ativo: secaoAtiva === 'importacao-sigaa' }"
            @click="secaoAtiva = 'importacao-sigaa'">
            Importação de dados SIGAA
          </div>
          <div class="item-lateral" :class="{ ativo: secaoAtiva === 'gerenciar-destaques' }"
            @click="secaoAtiva = 'gerenciar-destaques'">
            Carrossel de Destaques
          </div>
        </div>

        <!-- ÁREA DE CONTEÚDO -->
        <div class="conteudo-central" ref="conteudoRef">
          <!-- SEÇÃO: USUÁRIOS -->
          <div v-if="secaoAtiva === 'sem-nome-1'" class="usuarios-wrapper">
            <!-- LOADING -->
            <Carregamento v-if="
              false && !carregamentoInicialUsuariosConcluido && (loadingUsuarios || loadingCoordenadores) &&
              usuarios.length === 0 &&
              coordenadores.length === 0
            " :mensagemCarregamento="'Carregando usuários'" />

            <!-- ESTADO VAZIO -->
            <div v-else-if="
              false && !carregamentoInicialUsuariosConcluido && !loadingUsuarios &&
              !loadingCoordenadores &&
              usuarios.length === 0 &&
              coordenadores.length === 0
            " class="sem-noticias">
              <p>Nenhum usuário encontrado.</p>
            </div>

            <!-- GRID DE TABELAS SIDE-BY-SIDE -->
            <template v-else>
              <div class="titulo-gerenciamento">
                <h3>Menu de Gerenciamento de Credenciais</h3>
                <p>
                  Arraste os usuários entre as tabelas para adicionar ou remover
                  perfis
                </p>
              </div>
              <div class="tabelas-grid">
                <!-- PAINEL ESQUERDO: COORDENADORIA/PREX -->
                <div class="tabela-painel" :class="{ 'drag-over': dragOverPainel === 'coordenadores' }"
                  @dragover.prevent="dragOverPainel = 'coordenadores'" @dragleave="dragOverPainel = null"
                  @drop="onDropCoordenadores($event)">
                  <div class="painel-header">
                    <h5 class="painel-titulo">Coordenadoria / PREX</h5>
                  </div>
                  <div class="painel-filtro">
                    <div class="busca-campo busca-campo-dropdown" ref="dropdownUnidadeRef">
                      <div class="dropdown-trigger" @click="toggleDropdownUnidade">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)"
                          stroke-width="2" class="icone-unidade">
                          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                          <polyline points="9 22 9 12 15 12 15 22" />
                        </svg>
                        <span class="unidade-selecionada-texto">
                          {{ buscaUnidadeCoord || "Selecione uma unidade" }}
                        </span>
                        <svg class="seta-dropdown" :class="{ aberta: dropdownUnidadeAberto }" width="14" height="14"
                          viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2.5"
                          stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </div>

                      <!-- MENU SUSPENSO COM ALTURA CONTROLADA -->
                      <div v-if="dropdownUnidadeAberto" class="dropdown-menu-unidades">
                        <div class="dropdown-pesquisa" @click.stop>
                          <input v-model="filtroTextoUnidade" ref="inputFiltroUnidadeRef" type="text" name="filtro-unidade-prex" autocomplete="off"
                            placeholder="Buscar unidade..." class="input-filtro-dropdown" />
                        </div>
                        <ul class="dropdown-lista-itens">
                          <li class="dropdown-item" :class="{ ativo: buscaUnidadeCoord === 'PREX' }"
                            @click="selecionarUnidade('PREX')">
                            PREX
                          </li>
                          <li v-for="unidade in unidadesFiltradas" :key="unidade.id" class="dropdown-item" :class="{
                            ativo: buscaUnidadeCoord === unidade.nome,
                          }" @click="selecionarUnidade(unidade.nome)">
                            {{ unidade.nome.toUpperCase() }}
                          </li>
                          <li v-if="
                            unidadesFiltradas.length === 0 &&
                            !'PREX'
                              .toLowerCase()
                              .includes(filtroTextoUnidade.toLowerCase())
                          " class="dropdown-item-vazio">
                            Nenhuma unidade encontrada
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="tabela-scroll">
                    <div v-if="loadingCoordenadores && coordenadores.length === 0" class="tabela-vazia">
                      <p>Carregando coordenadores...</p>
                    </div>
                    <div v-else-if="coordenadores.length === 0" class="tabela-vazia">
                      <p>Nenhum coordenador encontrado.</p>
                    </div>
                    <table v-else class="tabela-usuarios">
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th>E-mail</th>
                          <th>Regras</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="usuario in coordenadores" :key="usuario.id" draggable="true" :class="{
                          dragging: dragItem?.id === usuario.id,
                          'linha-pendente-remover':
                            pendentesRebaixar.includes(usuario.id),
                        }" @dragstart="
                          onDragStart($event, usuario, 'coordenadores')
                          " @dragend="onDragEnd">
                          <td>{{ usuario.nome }}</td>
                          <td>{{ usuario.email }}</td>
                          <td class="celula-regras">
                            <span v-for="regra in usuario.regras" :key="regra" class="badge-regra"
                              :class="classeBadgeRegra(regra)">
                              {{ regra }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="painel-footer">
                    <div class="carregar-mais-container" v-if="temMaisCoordenadores">
                      <button class="btn-carregar-mais" @click="carregarMaisCoordenadores"
                        :disabled="loadingMaisCoordenadores">
                        <span v-if="loadingMaisCoordenadores" class="loading-dots">
                          <span></span><span></span><span></span>
                        </span>
                        <span v-else>Carregar mais</span>
                      </button>
                      <span class="info-paginacao">
                        {{ coordenadores.length }} de {{ totalCoordenadores }}
                      </span>
                    </div>
                    <div class="botoes-acao" v-if="pendentesRebaixar.length > 0">
                      <button class="btn-cancelar-mudancas" @click="desfazerRebaixamentos" :disabled="salvandoRebaixar">
                        Desfazer
                      </button>
                      <button class="btn-salvar-mudancas" @click="iniciarSalvamento('rebaixar')"
                        :disabled="salvandoRebaixar">
                        {{
                          salvandoRebaixar
                            ? "Salvando..."
                            : `Salvar Mudanças (${pendentesRebaixar.length})`
                        }}
                      </button>
                    </div>
                  </div>
                </div>

                <!-- COLUNA CENTRAL: INSTRUÇÕES -->
                <div class="instrucoes-drag">
                  <div class="instrucao-item">
                    <span class="seta">←</span>
                    <p>
                      Arraste para esta tabela para
                      <strong>dar credencial</strong>
                    </p>
                  </div>
                  <div class="instrucao-separador"></div>
                  <div class="instrucao-item">
                    <span class="seta">→</span>
                    <p>
                      Arraste para esta tabela para
                      <strong>remover credencial</strong>
                    </p>
                  </div>
                </div>

                <!-- PAINEL DIREITO: USUÁRIOS -->
                <div class="tabela-painel" :class="{ 'drag-over': dragOverPainel === 'usuarios' }"
                  @dragover.prevent="dragOverPainel = 'usuarios'" @dragleave="dragOverPainel = null"
                  @drop="onDropUsuarios($event)">
                  <div class="painel-header">
                    <h5 class="painel-titulo">Usuários</h5>
                  </div>
                  <div class="painel-filtro">
                    <div class="busca-campo">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)"
                        stroke-width="2">
                        <circle cx="11" cy="11" r="8" />
                        <path d="m21 21-4.3-4.3" />
                      </svg>
                      <input type="text" name="busca-usuarios-prex" autocomplete="off" v-model="buscaNomeUsuarios" placeholder="Buscar por nome..."
                        @keydown.enter="buscarUsuariosPadrao(0)" />
                    </div>
                  </div>
                  <div class="tabela-scroll">
                    <div v-if="loadingUsuarios && usuariosPadrao.length === 0" class="tabela-vazia">
                      <p>Carregando usuários...</p>
                    </div>
                    <div v-else-if="usuariosPadrao.length === 0" class="tabela-vazia">
                      <p>Nenhum usuário encontrado.</p>
                    </div>
                    <table v-else class="tabela-usuarios">
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th>E-mail</th>
                          <th>Regras</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="usuario in usuariosPadrao" :key="usuario.id" draggable="true" :class="{
                          dragging: dragItem?.id === usuario.id,
                          'linha-pendente-promover':
                            pendentesPromover.includes(usuario.id),
                        }" @dragstart="onDragStart($event, usuario, 'usuarios')" @dragend="onDragEnd">
                          <td>{{ usuario.nome }}</td>
                          <td>{{ usuario.email }}</td>
                          <td class="celula-regras">
                            <span v-for="regra in usuario.regras" :key="regra" class="badge-regra"
                              :class="classeBadgeRegra(regra)">
                              {{ regra }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="painel-footer">
                    <div class="carregar-mais-container" v-if="temMaisUsuarios">
                      <button class="btn-carregar-mais" @click="carregarMaisUsuarios" :disabled="loadingMaisUsuarios">
                        <span v-if="loadingMaisUsuarios" class="loading-dots">
                          <span></span><span></span><span></span>
                        </span>
                        <span v-else>Carregar mais</span>
                      </button>
                      <span class="info-paginacao">
                        {{ usuariosPadrao.length }} de {{ totalUsuarios }}
                      </span>
                    </div>
                    <div class="botoes-acao" v-if="pendentesPromover.length > 0">
                      <button class="btn-cancelar-mudancas" @click="desfazerPromocoes" :disabled="salvandoPromover">
                        Desfazer
                      </button>
                      <button class="btn-salvar-mudancas promover" @click="iniciarSalvamento('promover')"
                        :disabled="salvandoPromover">
                        {{
                          salvandoPromover
                            ? "Salvando..."
                            : `Salvar Mudanças (${pendentesPromover.length})`
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <!-- SEÇÕES SEM NOME (placeholders para seções futuras) -->
          <div v-if="
            secaoAtiva !== 'noticias' &&
            secaoAtiva !== 'sem-nome-1' &&
            secaoAtiva !== 'parcerias' &&
            secaoAtiva !== 'importacao-sigaa' &&
            secaoAtiva !== 'gerenciar-destaques'
          " class="secao-vazia">
            <p>Conteúdo em breve.</p>
          </div>
          <!-- SEÇÃO: IMPORTAÇÃO DE DADOS SIGAA -->
          <div v-if="secaoAtiva === 'importacao-sigaa'" class="importacao-wrapper">
            <ImportacaoSigaaView />
          </div>

          <!-- SEÇÃO: GERENCIAR CARROSSEL DE DESTAQUES -->
          <div v-if="secaoAtiva === 'gerenciar-destaques'" class="destaques-wrapper">
            <GerenciarDestaques />
          </div>

          <!-- SEÇÃO: PARCERIAS -->
          <div v-if="secaoAtiva === 'parcerias'" class="parcerias-wrapper">
            <ParceriasPrexDashboard />
          </div>

          <!-- SEÇÃO: CENTRAL PREX - LISTAGEM DE NOTÍCIAS -->
          <div v-if="secaoAtiva === 'noticias'" class="noticias-wrapper">
            <AnaliseNoticiasPrex ref="analiseNoticiasPrexRef" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalConfirmarSenha :mostrar="modalSenhaVisivel" :carregando="verificandoSenha" :erro="erroSenha"
    @cancelar="fecharModalSenha" @confirmar="onConfirmarSenha" />

  <Carregamento v-if="loading" />
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { formatarEnum } from "@/utils/FormatarEntradas";
import usuariosService from "@/service/usuariosService";
import unidadesService from "@/service/unidadesService";
import ImportacaoSigaaView from "@/views/usuarios/ImportacaoSigaaView.vue";
import GerenciarDestaques from "@/components/noticias/GerenciarDestaques.vue";
import AnaliseNoticiasPrex from "@/components/noticias/AnaliseNoticiasPrex.vue";
import ParceriasPrexDashboard from "@/components/parcerias/ParceriasPrexDashboard.vue";

import Carregamento from "@/components/common/Carregamento.vue";
import ModalConfirmarSenha from "@/components/usuarios/ModalConfirmarSenha.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import { useToast } from "@/composables/useToast";

const toast = useToast();

const route = useRoute();
const router = useRouter();
const destaques = ref([]);

const loading = ref(false);
const loadingNoticias = ref(false);
const dadosAcaoResponse = ref({});
const secaoAtiva = ref(route.query.tab || "noticias");
const telaAberta = ref(false);
const conteudoRef = ref(null);

// --- Estado da seção Usuários (tabela de usuários padrão) ---
const usuarios = ref([]);
const buscaNome = ref("");
const buscaUnidade = ref("");
const buscaNomeUsuarios = ref("");
const buscaUnidadeCoord = ref("SECRETARIA ACADEMICA/QUIXADA");
const loadingUsuarios = ref(false);
const carregamentoInicialUsuariosConcluido = ref(false);
const loadingMaisUsuarios = ref(false);
const paginaUsuarios = ref(0);
const totalPaginasUsuarios = ref(0);
const totalUsuarios = ref(0);
const enviandoRegra = ref(false);

// Drag-and-drop state
const dragItem = ref(null);
const dragOrigem = ref(null);
const dragOverPainel = ref(null);
const pendentesPromover = ref([]);
const pendentesRebaixar = ref([]);
const salvandoPromover = ref(false);
const salvandoRebaixar = ref(false);
const tamanhoPaginaUsuarios = 15;

// --- Estado da seção Coordenadores (tabela separada) ---
const coordenadores = ref([]);
const loadingCoordenadores = ref(false);
const loadingMaisCoordenadores = ref(false);
const paginaCoordenadores = ref(0);
const totalPaginasCoordenadores = ref(0);
const totalCoordenadores = ref(0);

const unidades = ref([]);

async function carregarUnidades() {
  try {
    const resposta = await unidadesService.getAllUnidades(0, 1000);
    const lista = Array.isArray(resposta) ? resposta : resposta?.content || [];
    unidades.value = [...lista].sort((a, b) =>
      (a.nome || "").localeCompare(b.nome || "")
    );
  } catch (error) {
    console.error("Erro ao carregar unidades:", error);
  }
}

const dropdownUnidadeAberto = ref(false);
const dropdownUnidadeRef = ref(null);
const filtroTextoUnidade = ref("");
const inputFiltroUnidadeRef = ref(null);

const unidadesFiltradas = computed(() => {
  if (!filtroTextoUnidade.value.trim()) return unidades.value;
  const termo = filtroTextoUnidade.value.trim().toLowerCase();
  return unidades.value.filter((u) =>
    (u.nome || "").toLowerCase().includes(termo)
  );
});

function toggleDropdownUnidade() {
  dropdownUnidadeAberto.value = !dropdownUnidadeAberto.value;
  if (dropdownUnidadeAberto.value) {
    filtroTextoUnidade.value = "";
    setTimeout(() => {
      inputFiltroUnidadeRef.value?.focus();
    }, 60);
  }
}

function selecionarUnidade(nome) {
  buscaUnidadeCoord.value = nome;
  dropdownUnidadeAberto.value = false;
  buscarUsuarios(0);
}

function handleClickForaDropdown(event) {
  if (
    dropdownUnidadeRef.value &&
    !dropdownUnidadeRef.value.contains(event.target)
  ) {
    dropdownUnidadeAberto.value = false;
  }
}

const temMaisUsuarios = computed(() => {
  return paginaUsuarios.value + 1 < totalPaginasUsuarios.value;
});

const temMaisCoordenadores = computed(() => {
  return paginaCoordenadores.value + 1 < totalPaginasCoordenadores.value;
});

const usuariosPadrao = computed(() => {
  return usuarios.value;
});

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Central Prex", to: "/central-prex" },
  ];
});

function classeBadgeRegra(regra) {
  const mapa = {
    COORDENADOR: "badge-coordenador",
    USUARIO: "badge-usuario",
    ALUNO: "badge-aluno",
    PREX: "badge-prex",
    COORDENADORIA: "badge-coordenadoria",
    ADMINISTRADOR: "badge-admin",
    LIDER: "badge-lider",
  };
  return mapa[regra] || "badge-default";
}

// Busca unificada: dispara as duas buscas (garante coordenadores primeiro para o filtro local funcionar)
async function buscarUsuarios(pagina = 0) {
  await buscarCoordenadoresLista(pagina);
  await buscarUsuariosPadrao(pagina);
}

async function buscarUsuariosPadrao(pagina = 0) {
  loadingUsuarios.value = true;
  paginaUsuarios.value = pagina;
  if (pagina === 0) usuarios.value = [];
  try {
    const response = await usuariosService.pesquisarUsuarios(
      pagina,
      tamanhoPaginaUsuarios,
      buscaNomeUsuarios.value,
      ""
    );
    let dadosUsuarios = response.content ?? [];

    // Filtro local para esconder os usuários que já são coordenadores na listagem esquerda
    dadosUsuarios = dadosUsuarios.filter(
      (u) => !coordenadores.value.find((c) => c.id === u.id)
    );

    if (pagina === 0) {
      usuarios.value = dadosUsuarios;
    } else {
      usuarios.value = [...usuarios.value, ...dadosUsuarios];
    }
    totalPaginasUsuarios.value = response.totalPages ?? 1;
    totalUsuarios.value = response.totalElements ?? 0;
    paginaUsuarios.value = response.number ?? pagina;
  } catch (error) {
    console.error("Erro ao buscar usuários:", error);
  } finally {
    loadingUsuarios.value = false;
    carregamentoInicialUsuariosConcluido.value = true;
  }
}

async function buscarCoordenadoresLista(pagina = 0) {
  loadingCoordenadores.value = true;
  paginaCoordenadores.value = pagina;
  if (pagina === 0) coordenadores.value = [];
  try {
    const isBuscaPrex = buscaUnidadeCoord.value === "PREX";

    const response = await usuariosService.pesquisarCoordenadores(
      pagina,
      tamanhoPaginaUsuarios,
      "",
      isBuscaPrex ? "" : buscaUnidadeCoord.value
    );

    let dados = response.content ?? [];

    if (isBuscaPrex) {
      dados = dados.filter((u) => u.regras && u.regras.includes("PREX"));
    }

    if (pagina === 0) {
      coordenadores.value = dados;
    } else {
      coordenadores.value = [...coordenadores.value, ...dados];
    }
    totalPaginasCoordenadores.value = response.totalPages ?? 1;
    totalCoordenadores.value = response.totalElements ?? 0;
    paginaCoordenadores.value = response.number ?? pagina;
  } catch (error) {
    console.error("Erro ao buscar coordenadores:", error);
  } finally {
    loadingCoordenadores.value = false;
  }
}

async function carregarMaisUsuarios() {
  if (loadingMaisUsuarios.value || !temMaisUsuarios.value) return;
  loadingMaisUsuarios.value = true;
  try {
    await buscarUsuariosPadrao(paginaUsuarios.value + 1);
  } finally {
    loadingMaisUsuarios.value = false;
  }
}

async function carregarMaisCoordenadores() {
  if (loadingMaisCoordenadores.value || !temMaisCoordenadores.value) return;
  loadingMaisCoordenadores.value = true;
  try {
    await buscarCoordenadoresLista(paginaCoordenadores.value + 1);
  } finally {
    loadingMaisCoordenadores.value = false;
  }
}

// --- Drag and Drop ---
function onDragStart(event, usuario, origem) {
  dragItem.value = usuario;
  dragOrigem.value = origem;
  event.dataTransfer.effectAllowed = "move";
  event.dataTransfer.setData("text/plain", usuario.id);
}

function onDragEnd() {
  dragItem.value = null;
  dragOrigem.value = null;
  dragOverPainel.value = null;
}

function onDropCoordenadores(event) {
  event.preventDefault();
  dragOverPainel.value = null;
  if (!dragItem.value || dragOrigem.value === "coordenadores") return;

  const usuario = dragItem.value;
  if (!pendentesPromover.value.includes(usuario.id)) {
    pendentesPromover.value.push(usuario.id);
    // Mover visualmente
    usuarios.value = usuarios.value.filter((u) => u.id !== usuario.id);
    coordenadores.value.unshift(usuario);
  }
  dragItem.value = null;
  dragOrigem.value = null;
}

function onDropUsuarios(event) {
  event.preventDefault();
  dragOverPainel.value = null;
  if (!dragItem.value || dragOrigem.value === "usuarios") return;

  const usuario = dragItem.value;
  if (!pendentesRebaixar.value.includes(usuario.id)) {
    pendentesRebaixar.value.push(usuario.id);
    // Mover visualmente
    coordenadores.value = coordenadores.value.filter(
      (c) => c.id !== usuario.id
    );
    usuarios.value.unshift(usuario);
  }
  dragItem.value = null;
  dragOrigem.value = null;
}

function desfazerPromocoes() {
  const movidos = coordenadores.value.filter((c) =>
    pendentesPromover.value.includes(c.id)
  );
  coordenadores.value = coordenadores.value.filter(
    (c) => !pendentesPromover.value.includes(c.id)
  );
  usuarios.value = [...movidos, ...usuarios.value];
  pendentesPromover.value = [];
}

function desfazerRebaixamentos() {
  const movidos = usuarios.value.filter((u) =>
    pendentesRebaixar.value.includes(u.id)
  );
  usuarios.value = usuarios.value.filter(
    (u) => !pendentesRebaixar.value.includes(u.id)
  );
  coordenadores.value = [...movidos, ...coordenadores.value];
  pendentesRebaixar.value = [];
}

const modalSenhaVisivel = ref(false);
const verificandoSenha = ref(false);
const erroSenha = ref("");
const acaoSenhaPendente = ref("");

function iniciarSalvamento(tipo) {
  acaoSenhaPendente.value = tipo;
  erroSenha.value = "";
  modalSenhaVisivel.value = true;
}

function fecharModalSenha() {
  modalSenhaVisivel.value = false;
  erroSenha.value = "";
}

async function onConfirmarSenha(senha) {
  verificandoSenha.value = true;
  erroSenha.value = "";
  try {
    const valida = await usuariosService.verificarSenha(senha);
    if (!valida) {
      erroSenha.value = "Senha do SIGAA incorreta. Tente novamente.";
      return;
    }
    fecharModalSenha();
    if (acaoSenhaPendente.value === "promover") {
      await executarPromocoes();
    } else if (acaoSenhaPendente.value === "rebaixar") {
      await executarRebaixamentos();
    }
  } catch (error) {
    erroSenha.value = "Erro ao validar senha do SIGAA.";
  } finally {
    verificandoSenha.value = false;
  }
}

async function executarPromocoes() {
  if (pendentesPromover.value.length === 0) return;
  salvandoPromover.value = true;
  try {
    const isPrex = buscaUnidadeCoord.value === "PREX";
    const regraParam = isPrex ? "PREX" : "COORDENADORIA";
    let unidadeIdParam = "";

    if (!isPrex) {
      if (unidades.value.length === 0) {
        await carregarUnidades();
      }
      const unidadeSelecionada = unidades.value.find(
        (u) =>
          u.nome === buscaUnidadeCoord.value ||
          u.nome?.trim().toLowerCase() === buscaUnidadeCoord.value?.trim().toLowerCase()
      );
      if (unidadeSelecionada) {
        unidadeIdParam = unidadeSelecionada.id;
      }
    }

    for (const id of pendentesPromover.value) {
      await usuariosService.promoverCoordenadoriaOuPrex(
        id,
        regraParam,
        unidadeIdParam
      );
    }
    toast.sucesso(
      pendentesPromover.value.length === 1 ? "Usuário alocado com sucesso!" : `${pendentesPromover.value.length} usuários alocados com sucesso!`
    );
    pendentesPromover.value = [];
    await buscarUsuariosPadrao(0);
    await buscarCoordenadoresLista(0);
  } catch (error) {
    console.error("Erro ao salvar promoções:", error);
    toast.erro("Erro ao alocar usuário(s). Tente novamente.");
  } finally {
    salvandoPromover.value = false;
  }
}

async function executarRebaixamentos() {
  if (pendentesRebaixar.value.length === 0) return;
  salvandoRebaixar.value = true;
  try {
    const isPrex = buscaUnidadeCoord.value === "PREX";
    const byPrex = isPrex;
    const byUnidade = buscaUnidadeCoord.value !== "" && !isPrex;

    for (const id of pendentesRebaixar.value) {
      await usuariosService.rebaixarCoordenador(id, byUnidade, byPrex);
    }
    toast.sucesso(
      pendentesRebaixar.value.length === 1 ? "Credencial removida com sucesso!" : `${pendentesRebaixar.value.length} credenciais removidas com sucesso!`
    );
    pendentesRebaixar.value = [];
    await buscarUsuariosPadrao(0);
    await buscarCoordenadoresLista(0);
  } catch (error) {
    console.error("Erro ao salvar rebaixamentos:", error);
    toast.erro("Erro ao remover credencial(is). Tente novamente.");
  } finally {
    salvandoRebaixar.value = false;
  }
}

// Estado do modal de tornar coordenador
const modalCoordenador = ref({
  visivel: false,
  usuario: null,
  unidadeId: "",
});

function abrirModalCoordenador(usuario) {
  modalCoordenador.value = {
    visivel: true,
    usuario: usuario,
    unidadeId: "",
  };
}

function fecharModalCoordenador() {
  modalCoordenador.value = {
    visivel: false,
    usuario: null,
    unidadeId: "",
  };
}

function confirmarTornarCoordenador() {
  const body = {
    unidadeId: modalCoordenador.value.unidadeId,
    usuarioId: modalCoordenador.value.usuario?.id,
  };
  // TODO: chamar o endpoint do backend quando estiver pronto
  // await usuariosService.tornarCoordenador(body.usuarioId, body.unidadeId);

  // Atualiza localmente para feedback visual
  const usuario = modalCoordenador.value.usuario;
  if (usuario && !usuario.regras.includes("COORDENADOR")) {
    usuario.regras.push("COORDENADOR");
  }
  fecharModalCoordenador();
}

async function removerCoordenador(usuario) {
  const confirmado = confirm(
    `Tem certeza que deseja remover "${usuario.nome}" como coordenador?`
  );
  if (!confirmado) return;

  enviandoRegra.value = true;
  try {
    const status = await usuariosService.rebaixarCoordenador(usuario.id);
    if (status === 200 || status === 204 || status === 201) {
      // Atualiza localmente para feedback visual
      const index = coordenadores.value.findIndex((c) => c.id === usuario.id);
      if (index > -1) {
        coordenadores.value.splice(index, 1);
      }

      // Remove a regra COORDENADOR localmente
      const regraIndex = usuario.regras.indexOf("COORDENADOR");
      if (regraIndex > -1) {
        usuario.regras.splice(regraIndex, 1);
      }

      // Adiciona na lista de usuários padrão se não estiver lá
      const userExists = usuarios.value.find((u) => u.id === usuario.id);
      if (!userExists) {
        usuarios.value.unshift(usuario);
      }

      toast.sucesso("Coordenador removido com sucesso!");
    } else {
      toast.erro("Erro ao remover coordenador.");
    }
  } catch (error) {
    console.error("Erro ao remover coordenador:", error);
    toast.erro("Erro ao remover coordenador.");
  } finally {
    enviandoRegra.value = false;
  }
}

const dadosAcao = computed(() => {
  return (
    dadosAcaoResponse.value || {
      titulo: "Título Padrão",
      nomeCoordenador: "Coordenador Padrão",
      tipoAcao: "Projeto",
    }
  );
});

const mapeamentoRotas = {
  atividades: "Atividades",
  noticias: "Notícias",
  informacoes: "Informações",
  declaracoes: "Minhas Declarações",
  tarefas: "Tarefas",
  "central-coordenacao": "Central da Ação",
  "central-prex": "Central Prex",
};

const rotaAtual = computed(() => {
  const path = route.path;
  for (const rota of Object.keys(mapeamentoRotas)) {
    if (path.includes(rota)) return rota;
  }
  return "";
});

const nomeDaRotaAtual = computed(() => {
  return mapeamentoRotas[rotaAtual.value] || "Página Atual";
});

const podeNavegarParaRotaAtual = computed(() => {
  const rotasSemLink = [
    "cadastrar-atividade",
    "cadastrar-noticia",
    "cadastrar-tarefa",
  ];
  return !rotasSemLink.some((rota) => route.path.includes(rota));
});

const analiseNoticiasPrexRef = ref(null);

let debounceBuscaUsuarios = null;
watch(buscaNomeUsuarios, () => {
  clearTimeout(debounceBuscaUsuarios);
  debounceBuscaUsuarios = setTimeout(() => {
    buscarUsuariosPadrao(0);
  }, 350);
});

watch(
  () => route.query.tab,
  (newTab) => {
    if (newTab) {
      secaoAtiva.value = newTab;
    }
  }
);

watch(secaoAtiva, (nova) => {
  if (nova === "noticias") {
    analiseNoticiasPrexRef.value?.buscarNoticiasPrex();
  }
  if (nova === "sem-nome-1") {
    if (unidades.value.length === 0) carregarUnidades();
    buscarUsuarios(0);
  }
});

onMounted(() => {
  document.addEventListener("mousedown", handleClickForaDropdown);
  if (secaoAtiva.value === "sem-nome-1") buscarUsuarios(0);
  carregarUnidades();
});

onUnmounted(() => {
  document.removeEventListener("mousedown", handleClickForaDropdown);
});
</script>

<style scoped>
#conteudo-acao {
  display: block;
  border-radius: 10px;
}

#titulo {
  padding: 0 20px 20px 20px;
  border-radius: 10px 10px 0 0;
}

#titulo h2 {
  font-size: 1.8rem;
  color: var(--cinza-escuro);
  margin-bottom: 0.5rem;
}

#titulo h4 {
  font-size: 1rem;
  color: var(--cinza-medio);
  margin: 0;
}

#menu-container {
  padding: 0;
}

#menus {
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 0;
  width: 100%;
  overflow: hidden;
}

.item {
  display: flex;
  flex: 1;
  min-width: 160px;
}

#menus .item a {
  width: 100%;
  border: none;
  padding: 12px 15px;
  font-size: 1rem;
  border-radius: 5px 5px 0 0;

  transition:
    background-color 0.3s ease,
    color 0.3s ease;
  color: var(--branco);
  background-color: var(--roxo-primario);
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  word-break: break-word;
  white-space: normal;
}

.ultimo-item a {
  border-right: none !important;
}

.opcao-selecionada a {
  background-color: var(--branco) !important;
  color: var(--preto) !important;
}

#conteudo-dinamico {
  padding: 0;
  min-height: 50vh;
}

/* LAYOUT CENTRAL PREX */
.central-layout {
  display: flex;
  border: 1px solid var(--roxo-primario);
  border-radius: 0px 0px 6px 6px;
  overflow: hidden;
  min-height: 400px;
}

.menu-lateral {
  width: 180px;
  flex-shrink: 0;
  background: var(--roxo-primario);
}

.item-lateral {
  padding: 12px 16px;
  color: var(--branco);
  font-size: 0.9rem;
  cursor: pointer;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  text-align: center;
  transition: background-color 0.2s ease;
}

.item-lateral:hover {
  background-color: hsla(0, 0%, 100%, 0.1);
}

.item-lateral.ativo {
  background-color: var(--branco);
  color: var(--roxo-primario);
  font-weight: 600;
}

.conteudo-central {
  flex: 1;
  background: var(--roxo-escuro);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  max-height: 800px;
  scroll-behavior: smooth;
}

.noticias-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid var(--roxo-superficie);
  border-top-color: var(--roxo-medio);
  border-radius: 50%;
  animation: girar 0.8s linear infinite;
}

@keyframes girar {
  to {
    transform: rotate(360deg);
  }
}

/* ESTADOS VAZIOS */
.secao-vazia,
.sem-noticias {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: hsla(0, 0%, 100%, 0.5);
  font-size: 0.95rem;
}

.spinner-noticias {
  text-align: center;
  padding: 40px;
  color: hsla(0, 0%, 100%, 0.6);
  font-size: 0.95rem;
}

.spinner {
  text-align: center;
  padding: 20px;
  font-size: 1.2rem;
  color: var(--roxo-primario);
}

/* RESPONSIVO */
@media (max-width: 768px) {
  .central-layout {
    flex-direction: column;
  }

  .menu-lateral {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .item-lateral {
    flex: 1 1 33%;
    border-right: 1px solid hsla(0, 0%, 100%, 0.1);
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }

  .conteudo-central {
    max-height: 70vh;
  }

  .item {
    flex: 1 1 50%;
    min-width: 120px;
  }

  #menus .item a {
    padding: 10px 8px;
    font-size: 0.9rem;
  }

  #titulo h2 {
    font-size: 1.6rem;
  }

  #titulo h4 {
    font-size: 0.9rem;
  }
}

@media (max-width: 576px) {
  #menus {
    flex-direction: column;
    border-top: none;
  }

  .item {
    flex: 1;
    min-width: 100%;
    border-bottom: 1px solid var(--cinza-claro);
  }

  #menus .item a {
    padding: 12px 15px;
    font-size: 1rem;
    border-right: none;
    border-bottom: 1px solid var(--branco);
  }

  .menu-lateral {
    flex-direction: column;
  }

  .item-lateral {
    flex: unset;
  }

  #conteudo-dinamico {
    padding: 0 15px;
  }
}

/* SEÇÃO USUÁRIOS - REDESIGN */
.usuarios-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.titulo-gerenciamento {
  text-align: center;
  margin-bottom: 24px;
  margin-top: 8px;
}

.titulo-gerenciamento h3 {
  color: var(--branco);
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  letter-spacing: 0.5px;
}

.titulo-gerenciamento p {
  color: hsla(0, 0%, 100%, 0.6);
  font-size: 0.9rem;
  margin: 0;
}

.tabelas-grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0;
  align-items: stretch;
  min-height: 400px;
}

/* PAINEL DE TABELA */
.tabela-painel {
  display: flex;
  flex-direction: column;
  border: 1px solid hsla(0, 0%, 100%, 0.12);
  border-radius: 8px;
  background: hsla(0, 0%, 100%, 0.04);
  overflow: hidden;
  transition:
    border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.tabela-painel.drag-over {
  border-color: var(--roxo-claro);
  box-shadow:
    inset 0 0 24px hsla(258, 70%, 58%, 0.15),
    0 0 16px hsla(258, 70%, 58%, 0.2);
}

.painel-header {
  padding: 16px;
  background: var(--roxo-primario);
  border-bottom: 2px solid hsla(258, 70%, 58%, 0.4);
}

.painel-titulo {
  color: var(--branco);
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.painel-filtro {
  padding: 12px 16px;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.08);
}

.tabela-scroll {
  flex: 1;
  overflow-y: auto;
  max-height: 350px;
  scrollbar-width: thin;
  scrollbar-color: hsla(258, 70%, 58%, 0.4) transparent;
}

.tabela-scroll::-webkit-scrollbar {
  width: 6px;
}

.tabela-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.tabela-scroll::-webkit-scrollbar-thumb {
  background: hsla(258, 70%, 58%, 0.4);
  border-radius: 3px;
}

.painel-footer {
  padding: 12px 16px;
  border-top: 1px solid hsla(0, 0%, 100%, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.parcerias-wrapper {
  --parcerias-titulo-cor: var(--branco);
  --parcerias-subtitulo-cor: var(--roxo-superficie);
}

/* INSTRUÇÕES CENTRAIS */
.instrucoes-drag {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  gap: 24px;
  min-width: 140px;
}

.instrucao-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
}

.instrucao-item .seta {
  font-size: 1.8rem;
  color: var(--roxo-claro);
  font-weight: 700;
  line-height: 1;
}

.instrucao-item p {
  font-size: 0.75rem;
  color: hsla(0, 0%, 100%, 0.5);
  margin: 0;
  max-width: 120px;
  line-height: 1.4;
}

.instrucao-item p strong {
  color: hsla(0, 0%, 100%, 0.8);
}

.instrucao-separador {
  width: 40px;
  height: 1px;
  background: hsla(0, 0%, 100%, 0.15);
}

/* DRAG STYLES */
.tabela-usuarios tbody tr[draggable="true"] {
  cursor: grab;
  transition:
    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.15s ease;
}

.tabela-usuarios tbody tr[draggable="true"]:active {
  cursor: grabbing;
}

.tabela-usuarios tbody tr.dragging {
  opacity: 0.4;
}

.linha-pendente-promover {
  background: hsla(258, 70%, 58%, 0.15) !important;
  border-left: 3px solid var(--roxo-claro);
}

.linha-pendente-remover {
  background: hsla(0, 72%, 51%, 0.12) !important;
  border-left: 3px solid var(--vermelho);
}

/* BOTOES ACAO */
.botoes-acao {
  display: flex;
  width: 100%;
  gap: 8px;
}

.btn-cancelar-mudancas {
  background: transparent;
  color: hsla(0, 0%, 100%, 0.6);
  border: 1px solid hsla(0, 0%, 100%, 0.2);
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-cancelar-mudancas:hover:not(:disabled) {
  background: hsla(0, 0%, 100%, 0.1);
  color: var(--branco);
}

/* BOTÃO SALVAR MUDANÇAS */
.btn-salvar-mudancas {
  background: var(--vermelho);
  color: var(--branco);
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.1s ease;
  width: 100%;
}

.btn-salvar-mudancas:hover:not(:disabled) {
  background: var(--vermelho);
  transform: translateY(-1px);
}

.btn-salvar-mudancas.promover {
  background: var(--roxo-claro);
}

.btn-salvar-mudancas.promover:hover:not(:disabled) {
  background: var(--roxo-medio);
}

.btn-salvar-mudancas:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* BUSCA (mantém estilos existentes, só refinamentos) */
.busca-campo {
  display: flex;
  align-items: center;
  gap: 8px;
  background: hsla(0, 0%, 100%, 0.08);
  border: 1px solid hsla(0, 0%, 100%, 0.15);
  border-radius: 6px;
  padding: 0 12px;
  width: 100%;
}

.busca-campo input {
  background: transparent;
  border: none;
  outline: none;
  color: var(--branco);
  font-size: 0.85rem;
  padding: 8px 0;
  width: 100%;
}

.busca-campo input::placeholder {
  color: hsla(0, 0%, 100%, 0.4);
}

.busca-campo select {
  background: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  color: var(--branco);
  font-size: 0.85rem;
  padding: 8px 28px 8px 0;
  width: 100%;
  cursor: pointer;
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='hsla(0, 0%, 100%, 0.6)' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
  background-repeat: no-repeat !important;
  background-position: right 8px center !important;
}

.busca-campo select:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

.busca-campo select::-ms-expand {
  display: none;
}

.busca-campo select option {
  background: var(--roxo-escuro);
  color: var(--branco);
}

/* DROPDOWN CUSTOMIZADO DE UNIDADES */
.busca-campo-dropdown {
  position: relative;
  cursor: pointer;
  user-select: none;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 0;
  min-height: 38px;
}

.icone-unidade {
  flex-shrink: 0;
}

.unidade-selecionada-texto {
  flex: 1;
  color: var(--branco);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.seta-dropdown {
  flex-shrink: 0;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.seta-dropdown.aberta {
  transform: rotate(180deg);
}

.dropdown-menu-unidades {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: var(--roxo-escuro);
  border: 1px solid hsla(258, 70%, 58%, 0.4);
  border-radius: 8px;
  box-shadow:
    0 10px 15px -3px hsla(0, 0%, 0%, 0.2),
    0 4px 6px -2px hsla(0, 0%, 0%, 0.1);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dropdown-pesquisa {
  padding: 8px;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  background: hsla(0, 0%, 0%, 0.2);
}

.input-filtro-dropdown {
  width: 100%;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid hsla(0, 0%, 100%, 0.2);
  background: hsla(0, 0%, 100%, 0.08);
  color: var(--branco);
  font-size: 12px;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-filtro-dropdown:focus {
  border-color: var(--roxo-claro);
  background: hsla(0, 0%, 100%, 0.12);
}

.dropdown-lista-itens {
  list-style: none;
  margin: 0;
  padding: 4px 0;
  max-height: 240px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: hsla(258, 70%, 58%, 0.4) transparent;
}

.dropdown-lista-itens::-webkit-scrollbar {
  width: 6px;
}

.dropdown-lista-itens::-webkit-scrollbar-thumb {
  background: hsla(258, 70%, 58%, 0.4);
  border-radius: 3px;
}

.dropdown-item {
  padding: 8px 12px;
  color: hsla(0, 0%, 100%, 0.85);
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-item:hover {
  background: hsla(258, 70%, 58%, 0.3);
  color: var(--branco);
}

.dropdown-item.ativo {
  background: var(--roxo-claro);
  color: var(--branco);
  font-weight: 600;
}

.dropdown-item-vazio {
  padding: 12px;
  color: hsla(0, 0%, 100%, 0.4);
  font-size: 12px;
  text-align: center;
}

/* TABELA (mantém) */
.tabela-container {
  overflow-x: auto;
  border-radius: 6px;
  border: 1px solid hsla(0, 0%, 100%, 0.1);
}

.tabela-usuarios {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.tabela-usuarios thead th {
  background: var(--roxo-primario);
  color: var(--branco);
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid hsla(0, 0%, 100%, 0.15);
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.tabela-usuarios tbody tr {
  background: hsla(0, 0%, 100%, 0.03);
  transition: background 0.15s ease;
}

.tabela-usuarios tbody tr:hover {
  background: hsla(0, 0%, 100%, 0.08);
}

.tabela-usuarios tbody tr:nth-child(even) {
  background: hsla(0, 0%, 100%, 0.05);
}

.tabela-usuarios tbody tr:nth-child(even):hover {
  background: hsla(0, 0%, 100%, 0.1);
}

.tabela-usuarios td {
  padding: 8px 12px;
  color: hsla(0, 0%, 100%, 0.85);
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.06);
  white-space: nowrap;
}

.celula-regras {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.badge-regra {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.badge-coordenador {
  background: hsla(258, 70%, 58%, 0.2);
  color: var(--roxo-superficie);
  border: 1px solid hsla(258, 70%, 58%, 0.4);
}

.badge-usuario {
  background: hsla(0, 0%, 60%, 0.2);
  color: var(--cinza-claro);
  border: 1px solid hsla(0, 0%, 60%, 0.4);
}

.badge-aluno {
  background: hsla(0, 0%, 60%, 0.2);
  color: var(--cinza-claro);
  border: 1px solid hsla(0, 0%, 60%, 0.4);
}

.badge-prex {
  background: hsla(29, 100%, 50%, 0.2);
  color: var(--laranja);
  border: 1px solid hsla(29, 100%, 50%, 0.4);
}

.badge-coordenadoria {
  background: hsla(135, 45%, 35%, 0.2);
  color: var(--verde-claro);
  border: 1px solid hsla(135, 45%, 35%, 0.4);
}

.badge-admin {
  background: hsla(0, 72%, 51%, 0.2);
  color: var(--vermelho-claro);
  border: 1px solid hsla(0, 72%, 51%, 0.4);
}

.badge-lider {
  background: hsla(0, 0%, 60%, 0.2);
  color: var(--cinza-medio);
  border: 1px solid hsla(0, 0%, 60%, 0.4);
}

.badge-default {
  background: hsla(0, 0%, 60%, 0.2);
  color: var(--cinza-claro);
  border: 1px solid hsla(0, 0%, 60%, 0.3);
}

.tabela-vazia {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  color: hsla(0, 0%, 100%, 0.4);
  font-size: 0.85rem;
  border: 1px dashed hsla(0, 0%, 100%, 0.15);
  border-radius: 6px;
  margin: 12px;
}

.importacao-wrapper {
  width: 100%;
}

/* TABELA SEÇÃO (legacy, keeping for other sections) */
.tabela-secao {
  margin-bottom: 20px;
}

.tabela-titulo {
  color: var(--branco);
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 2px solid hsla(258, 70%, 58%, 0.4);
}

/* RESPONSIVO para tabelas grid */
@media (max-width: 1024px) {
  .tabelas-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .instrucoes-drag {
    flex-direction: row;
    min-width: unset;
    padding: 12px 16px;
  }

  .instrucao-separador {
    width: 1px;
    height: 40px;
  }
}
</style>
